import { render, staticRenderFns } from "./SafetyManageDocDetail.vue?vue&type=template&id=107a9930&scoped=true&"
import script from "./SafetyManageDocDetail.vue?vue&type=script&lang=js&"
export * from "./SafetyManageDocDetail.vue?vue&type=script&lang=js&"
import style0 from "./SafetyManageDocDetail.vue?vue&type=style&index=0&id=107a9930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107a9930",
  null
  
)

export default component.exports